export default __webpack_public_path__ + "images/2c4cbb43783ffe08d57ba5b097f45d98.svg";